import React, { useEffect, useState, useMemo } from 'react';
import StickyMenu from '../../components/common/StickyMenu';
import FilterDataTable from '../../pages/instructor/FilterDataTable';
import adminServices from '../../services/adminServices';
import learnerService from '../../services/learnerService';
import Footer from '../shared/Footer';
import Navbar from '../shared/Navbar';
import SettingsPanel from '../shared/SettingsPanel';
import Sidebar from '../shared/Sidebar';
import DataTable from "react-data-table-component";
import service, { URI, USER_API } from '../../services/service';
import swal from 'sweetalert';
import { Button, Modal, Col, Row } from 'react-bootstrap';
import UserService from '../../services/UserService';
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import moment from 'moment';
import jsPDF from 'jspdf';
import { downloadExcel } from 'react-export-table-to-excel';
import axios from 'axios';
import { PreviewModal } from '../../pages/instructor/instCourses/CourseStructureDriveNew';
import Select from "react-select";
import { Styles } from "../../../src/pages/account/styles/Register.js";
import CryptoJS from "crypto-js";

const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },

    //{
    //     code: 'hi',
    //     name: 'Hindi',
    //     country_code: 'in'
    // },
    // {
    //     code: 'te',
    //     name: 'Telugu',
    //     country_code: 'in'
    // },
    // {
    //     code: 'pu',
    //     name: 'Punjabi',
    //     country_code: 'in'
    // },
    // {
    //     code : 'mr',
    //     name : 'Marathi',
    //     country_code : 'in'
    // }
]

const customStyles = {
    title: {
        style: {
            fontColor: 'red',
            fontWeight: '900',
        }
    },
    headCells: {
        style: {
            fontSize: '17px',
            fontWeight: '500',
            paddingLeft: '0 8px',
            marginLeft: '10px',
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            paddingLeft: '0 8px',
            marginLeft: '10px'
        },
    },
};

const DropdownMenuComponent = ({
    getCourses,
    selectedValues,
    onSelectionChange,
}) => {
    const handleChange = (selectedCourses) => {
        const selectedValues = selectedCourses.map((option) => option.value);
        onSelectionChange(selectedValues);
    };

    return (
        <Styles>
            <div className='form-field'>
                <Select
                    isMulti
                    options={getCourses}
                    value={getCourses?.filter((option) =>
                        selectedValues.includes(option.value)
                    )}
                    onChange={handleChange}
                    placeholder="Select Course(s)"
                />
            </div>
        </Styles>
    );
};

function IVPEventMapping() {

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()

    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])

    const [getEventsData, setEventsData] = useState([]);
    const [getEventCourseUrl, setEventCourseUrl] = useState();
    const [getIVPEventsData, setIVPEventsData] = useState([
        { value: {id: 0, event_name: " ", uni_code: " "}, label: "Select Event"}
      ]);

    useEffect(() => {
        EventsData();
        Courses();
    }, []);

    useEffect(() => {
        AllIVPEvent();
    }, [getEventsData]);

    const EventsData = () => {
        service
          .getAllEvents()
          .then((res) => {
            setEventsData(res.data);
          })
          .catch((err) => {
    
          });
      };


    // const addIVPEventintoList = (Event) => {

    //     Event.map(newEvent =>{
    //         setIVPEventsData((prevEvents) => [
    //             ...prevEvents,
    //             { value: {id: newEvent?.id, event_name: newEvent?.event_name, uni_code: newEvent?.event_unicode }, label: newEvent?.event_name}
    //           ]);
    //     })
    //   };

      // Add IVP Event into List after filtering out duplicate and existing events
  const addIVPEventintoList = (events) => {
    // Extract all event ids from allEventsData
    if(getEventsData.length != 0){
    const allEventIds = new Set(getEventsData.map((event) => event.eventId));
    // Filter and deduplicate IVP events
    const filteredIVPEvents = [];
    const ivpEventIds = new Set();

    events.forEach((newEvent) => {
      const eventId = newEvent?.id;
      // Check if eventId exists in allEventsData or is already in ivpEventIds
      if (!allEventIds.has(eventId)) {
        ivpEventIds.add(eventId); // Track unique event ids
        filteredIVPEvents.push({
          value: {
            id: eventId,
            event_name: newEvent?.event_name,
            uni_code: newEvent?.event_unicode,
          },
          label: newEvent?.event_name,
        });
      }
    });
    // Update state with filtered IVP events
    setIVPEventsData(filteredIVPEvents);
    }
    else{

    }
  };

    const AllIVPEvent = () =>{
        if(getEventsData.length != 0){
        service.getAllEventfromIVP()
        .then((res) =>{
            
            const upcomingEvents = res.data.data.upcoming_events;
            const ongoingEvents = res.data.data.ongoing_events;
            const closedEvents = res.data.data.closed_events;
            const allIVPEvents = [...upcomingEvents, ...ongoingEvents, ...closedEvents];
            addIVPEventintoList(allIVPEvents);
        }).catch(err =>{

        })
    }
    }

    const Courses = () =>{
        learnerService.getPublishCourses()
        .then(res => {
            const courseData = res.data.map((single) => {
                return {
                    value: single.courseId,
                    label: single.courseName,
                }
            })
            setCourses(courseData);
        })
        .catch(err => {
            
        })
    }

    
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [getCourses, setCourses] = useState([]);

      /* Table content Filter and Search */
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
    const filteredItems = getEventsData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
    );

    const [infoLoading, setInfoLoading] = useState({
        isLoading: false
    })
    const [eventNameErr, setEventNameErr] = useState()

    const [ShareEventModal, setShareEventModal] = useState({
        show: false
    });

    const [ShareAddEventModal, setShareAddEventModal] = useState({
        show: false
    });

    const [getIVPEventCurrentObject, setIVPEventCurrentObject] = useState();
    const [getEventName, setEventName] = useState();


    const validate = () => {
        var EventNameE = "";
        if (!getEventName) {
            EventNameE = `Please enter event name`
            setEventNameErr(EventNameE)
            return false;
        }
        else if (getEventName.length > 50) {
            EventNameE = `Event name length must be less then 50`
            setEventNameErr(EventNameE)
            return false;
        }
        else if (getEventName.length < 2) {
            EventNameE = `Event name length must be greater then 2`
            setEventNameErr(EventNameE)
            return false;
        }
        else if (getEventName.match(/^[A-Za-z0-9&()\/\- ]+$/)) {
            EventNameE = "";
            setEventNameErr(EventNameE)
            return true;
        }
        else {
            EventNameE = "Special Characters are not allowed";
            setEventNameErr(EventNameE)
            return false;
        }
    }


    const shareEventModalHide = () => {
        setShareEventModal({ show: false });
        setInfoLoading({ isLoading: false });
        setIVPEventCurrentObject();
    }
    const shareAddEventModalHide = () => {
        setShareAddEventModal({ show: false });
        setIVPEventCurrentObject();
    }
    

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
          if (filterText) {
            setResetPaginationToggle(!resetPaginationToggle);
            setFilterText("");
          }
        };
    
        return (
          <FilterDataTable
            onFilter={(e) => setFilterText(e.target.value)}
            onClear={handleClear}
            filterText={filterText}
          />
        );
      }, [filterText, resetPaginationToggle]);


      const handleSelectionChange = (selectedCourses) => {
        setSelectedCourses(selectedCourses);
        
    };

    const deleteEvent = (eventId) => {
            service.deleteIVPEvent(eventId)
            .then((res =>{
                if(res.data == "success")
                swal("Success!", "Event Deleted Successfully !!", "success");
            })).catch(err =>{
                    swal(t("error"), "Something went wrong while deleting Event", "error");
            })
    }

    const AddIVPEvent = () => {
        let status = validate();
        if(status){
            let data = {
            eventId : getIVPEventCurrentObject?.id,
            eventName: getIVPEventCurrentObject?.event_name,
            eventUnicode: getIVPEventCurrentObject?.uni_code,
            courseid:selectedCourses
        }
      
        service.AddIVPEventAPI(data)
        .then(res =>{
            if(res.status == 200){
                swal("Success!", "Event Added Successfully !!", "success");
            }
         shareAddEventModalHide();
         setIVPEventCurrentObject();
        }).catch(err =>{
            swal(t("error"), "Something went wrong while Adding Event", "error");
         shareAddEventModalHide();
         setIVPEventCurrentObject();
        })
    }

    }

    const addEvent = () =>{
        let a = [];
        // setInfoLoading({ isLoading: true });
        setShareAddEventModal({ show: true });
        setSelectedCourses(a);
    }

    const UpdateIVPEvent = () => {
        let status = validate();

        if(status){
        let data = {
            eventId : getIVPEventCurrentObject?.eventId,
            eventName: getEventName,
            eventUnicode: "",
            courseid:selectedCourses
        }
         

       service.UpdateIVPEventAPI(data)
       .then(res =>{
        if(res.status == 200){
            swal("Success!", "Event updated Successfully !!", "success");
        }
        shareEventModalHide();
        setIVPEventCurrentObject();
       }).catch(err =>{
        swal(t("error"), "Something went wrong while updating Event", "error");
        shareEventModalHide();
        setIVPEventCurrentObject();
       })
    }
    }

    const editEvent = (EventObject) =>{
        let a = [];
        setInfoLoading({ isLoading: true });
        setShareEventModal({ show: true });
        setEventName(EventObject.eventName);
        setIVPEventCurrentObject(EventObject);
        for(let  i=0; i < EventObject.courseMasters?.length ; i++){
            a.push(EventObject?.courseMasters[i]?.courseId);
        }
        setSelectedCourses(a);
    }


    const onChangeEventHandler = (e) => {
        setEventName(e.target.value.event_name);
    }

    // const onAddEventHandler = (e) => {
    //     setEventName(e.target.value.event_name)
    //     setIVPEventCurrentObject(e.target.value);
    // }

    const onAddEventHandler = (selectedOption) => {

        if (selectedOption) {
          setEventName(selectedOption.value.event_name)
          const selectedEvent = selectedOption.value; // Direct access to value
          setIVPEventCurrentObject(selectedEvent);
        } else {
          // Handle case when no option is selected (e.g., clear selection)
          setIVPEventCurrentObject(null);
        }
      };
      


    const columns = [
        {
            name: "S.No",
            selector: (row, index) => index + 1,
            wrap: true,
            width: "150px",
        },
        {
          name: "Event Name",
          selector: (row) => `${row.eventName}`,
          sortable: true,
          wrap: true,
        },
        {
            name: "Courses Mapped",
            //selector: row => row.gpfno,
            sortable: true,
            cell: (row) => <div>
              <div className="d-inline-block">
                   {row.courseMasters.length != 0? (<div>
                    {row.courseMasters.map((courses, index) => {
                        return (
                            <div key={courses.courseId} style={{margin:"5px"}}> 
                                {index + 1}. {courses.courseName}
                            </div>
                        );
                    })}
                    </div>):(<div>
                            0 Courses are Mapped
                        </div>)}
              </div>
            </div>
      
          },
          {
            name: "Action",
            sortable: true,
            wrap: true,
            cell: (row) => <div>
                <button className='btn btn-primary m-3' 
                onClick={() => editEvent(row)} disabled={infoLoading.isLoading ? "true" : ""}>
                {infoLoading.isLoading ? getIVPEventCurrentObject?.eventId === row.eventId ? (<> <i class="fa fa-spinner fa-spin" Styles={{fontSize:"24px"}}></i></>) : (<><i class="fas fa-edit"></i>  </>) : (<><i class="fas fa-edit"></i> </>)}
                    </button>
                <button className='btn btn-danger' 
                onClick={() => deleteEvent(row.eventId)}
                > <i class="fas fa-trash"></i> </button>
            </div>
        }
    ]


    return (
        <div className="container-scroller">
            <Navbar />
            <StickyMenu />
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div>
                            <div className="page-header">
                                <h3 className="page-title">
                                    IVP Event Mapping
                                </h3>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="!#" onClick={event => event.preventDefault()}>Courses</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">IVP Event Mapping</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <div>    
                                    <Row>
                                      <Col sm={10}>
                                        {/* Optional content or left side alignment */}
                                      </Col>
                                      <Col sm={2} className="text-end">
                                        <Button variant="success" onClick={() => addEvent()}>
                                          Add New Event from IVP
                                        </Button>
                                      </Col>
                                    </Row>
                                    </div>
                                    <div>
                                        <Col sm ={5}>
                                        <h4>Current Events</h4>
                                        </Col>
                                <DataTable
                                    columns={columns}
                                    data={filteredItems}
                                    defaultSortField="Name"
                                    defaultSortAsc={true}
                                    striped
                                    pagination
                                    highlightOnHover
                                    customStyles={customStyles}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                  />
                                  </div>
                                
                                </div>
                            </div>
                        </div>
                        <SettingsPanel />
                    </div>
                    <Footer />
                </div>
            </div>
            <Modal centered show={ShareEventModal.show} onHide={() => shareEventModalHide()} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
                       Edit {getIVPEventCurrentObject?.eventName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <div className='form-field'>
                    <label> Event Name: </label>
                    <div class="mb-3 mt-3">
                        <label for="name">{t('name')} : *</label>
                        <input type="text" disabled class="form-control" placeholder="Event Name" onChange={onChangeEventHandler} value={getIVPEventCurrentObject?.eventName} />
                        {
                            eventNameErr
                                ?
                                <div className="alert alert-danger mt-2">
                                    {eventNameErr}
                                </div>
                                :
                                <>
                                </>
                        }
                    </div>
                    {/* <div class="mb-3 mt-3">
                        <label for="unicode">EVENT UNICODE: </label>
                        <input type="text" disabled class="form-control" placeholder="Event unicode" value={getIVPEventCurrentObject?.eventUnicode} />
                    </div> */}
                    <label>Select Course:</label>
                    <DropdownMenuComponent
                        onSelectionChange={handleSelectionChange}
                        getCourses={getCourses}
                        selectedValues={selectedCourses}
                    />
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ justifyContent: "right" }}>
                    <Button variant="primary" 
                    onClick={() => UpdateIVPEvent()}
                    >
                        Update
                    </Button>

                    <Button variant="secondary" 
                    onClick={() => shareEventModalHide()}
                    >
                        {t('cancel')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal centered show={ShareAddEventModal.show} onHide={() => shareAddEventModalHide()} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
                       Add Event
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <div className='form-field'>                    
                   <div className="mb-3 mt-3">
                          <label>Event Name:</label> {' '}
                          <Select
                        value={getIVPEventCurrentObject 
                            ? { value: getIVPEventCurrentObject, label: getIVPEventCurrentObject.event_name }
                            : null
                          }
                        onChange={onAddEventHandler}
                        options={getIVPEventsData}
                        placeholder="Select an event..."
                        className='flex-grow'
                        isClearable
                      />
                        </div>
                    <label>Select Course:</label>
                    <DropdownMenuComponent
                        onSelectionChange={handleSelectionChange}
                        getCourses={getCourses}
                        selectedValues={selectedCourses}
                    />
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ justifyContent: "right" }}>
                    <Button variant="primary" 
                    onClick={() => AddIVPEvent()}
                    >
                        Add
                    </Button>

                    <Button variant="secondary" 
                    onClick={() => shareAddEventModalHide()}
                    >
                        {t('cancel')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>

    );
}

export default IVPEventMapping;